module.exports = __webpack_public_path__ + "static/img/erm2.dd93852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/erm2.png
// module id = NeAt
// module chunks = 37